import type { ColumnDef } from '@tanstack/react-table';
import type { AverageDaysRow } from '../../../services/accountingReports.service';
import { formatCurrency } from '../../../utils/money';

type Col = ColumnDef<AverageDaysRow>;
const money = (accessorKey: string, header: string): Col => ({
  accessorKey, header, size: 140,
  cell: ({ getValue }) => formatCurrency(getValue()), meta: { aggType: 'sum' },
});
const day = (accessorKey: string, header: string): Col => ({
  accessorKey, header, size: 140, meta: { isDate: true, showTime: false },
});
const txt = (accessorKey: string, header: string, size = 160): Col => ({ accessorKey, header, size });

/** V1 reports_cms.pl:2493–2502, one row per invoice-history/bill-to pair. */
export const avgDaysColumns: Col[] = [
  txt('createdby', 'Created By'), day('invoicedate', 'Invoice Date'),
  txt('invoicenumber', 'Invoice #'), txt('customer', 'Customer', 220), txt('csr', 'CSR'),
  day('lastdelivery', 'Delivery Date'), money('invoicetotal', 'Invoice Amt'),
  txt('daysdiff', 'Days to Invoice'),
];
